import React, {useContext, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import axios from 'axios';
import useNotification from '../../../hooks/useNotification';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function DeletePanelDialog(props) {

    const auth = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const { notificationSuccess, notificationError, notificationWarning } = useNotification();

    const deletePanel = async() => {
        try {
            setLoading(true);
        
            if(!props.lastCellData.idEntita.S)return;

            const essentialData = {
                idEntita: props.lastCellData.idEntita.S,
                city: props.lastCellData.city.S,
            }

            const axiosParams = {
                url: '/delete-panel',
                method: 'post',
                baseURL: config.API_URL,
                headers: {
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: essentialData
            };

            await axios(axiosParams);
            notificationSuccess('Pannello Eliminato');

            /* if(response.data?.resultsToPass?.some(el => el.status === 'rejected')){
                let arrElementsFailed = response.data.resultsToPass.filter(el => el.status === 'rejected').map(el => el.reason);
                notificationWarning(`I seguenti punti di interesse non sono stati trovati: ${arrElementsFailed}`);
            } */

            await props.getPanels();
            props.handleCloseDeletePanelDialog();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    return (
        <Dialog className="" open={props.openDeletePanelDialog} onClose={props.handleCloseDeletePanelDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Elimina pannello - {props?.lastCellData?.idEntita.S}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Vuoi eliminare l'impianto con id {props?.lastCellData?.idEntita.S} della fermata "{props?.lastCellData?.idFermata.S + ' ' || ''}{props?.lastCellData?.nome.S || ''}"?
                </DialogContentText>
                <DialogContentText>L'azione è irreversibile.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={deletePanel}>
                    Elimina
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseDeletePanelDialog}>
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DeletePanelDialog